import React, { useState, useEffect } from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import { useNavigate } from "react-router-dom";
import { FormTypeAdd, FormTypeEdit } from "utils/Constant";
import { DateFormat, money } from "utils/helpers";
import { useModal } from "context/ModalContext";
import { MainBodyCard, PagesFormTitle } from "components/Cards";
import { ExpenseCategoryService } from "services/ExpenseCategory/ExpenseCategoryService";
import Select from 'react-select'
import DatePicker from "components/Input/DatePicker";
import { ExpenseService } from "services/Expense/ExpenseService";

export default function ExpenseForm(){
    let navigate = useNavigate()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchExpenseCategoryList } = ExpenseCategoryService()
    const { fetchCreateExpense, fetchUpdateExpense, fetchExpenseById } = ExpenseService()
    
    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let expenseId = queryString.get("expenseId")

    const [expenseCategoryOptions, setExpenseCategoryOptions] = useState([])
    const [expenseCategoryId, setExpenseCategoryId] = useState('')
    const [expenseDate, setExpenseDate] = useState(new Date())
    const [amount, setAmount] = useState('')
    const [description, setDescription] = useState('')
    
    const [status, setStatus] = useState('')
    const [createBy, setCreateBy] = useState('')
    const [createDate, setCreateDate] = useState('')
    const [updateBy, setUpdateBy] = useState('')
    const [updateDate, setUpdateDate] = useState('')
    
    // Button Event
    const saveBtnClick = async () => {
        if(!validation()) return

        const onConfirm = await confirm()
        if (!onConfirm) return

        showLoading()

        try {
            if (formType === FormTypeAdd) {
                await insertExpense()
            } else {
                await updateExpense()
            }

            showSuccess({
                onSuccess: () => {
                    navigate("/expenses")
                }
            })
        }
        finally {
            hideLoading()
        }
    }
    const backBtnClick = () => {
        navigate('/expenses')
    }

    // Function
    const validation = () => {
        if (expenseCategoryId === ''){
            showFail('Category is required!')
            return false
        }
        if (amount === '') {
            showFail('Jumlah is required!')
            return false
        }
        if (description === '') {
            showFail('Deskripsi is required!')
            return false
        }

        return true
    }

    const getExpenseCategory = async () => {
        const res = await fetchExpenseCategoryList('', '1', 100, 0)
        if (!res) return

        const data = res?.data?.listData
        const options = data.map((x) => ({ label: x.expenseCategoryName, value: String(x.expenseCategoryId) }))

        setExpenseCategoryOptions(options)
    }
    const insertExpense = async () => {
        const res = await fetchCreateExpense(expenseCategoryId, amount.replaceAll(',', ''), description, DateFormat(expenseDate))
        if (!res) return
    }
    const updateExpense = async () => {
        const res = await fetchUpdateExpense(expenseId, expenseCategoryId, amount.replaceAll(',', ''), description, DateFormat(expenseDate))
        if (!res) return
    }
    const getExpenseById = async (id) => {
        const res = await fetchExpenseById(id)
        if (!res) return

        const data = res.data

        setExpenseDate(data.expenseDate)
        setExpenseCategoryId(String(data.expenseCategoryId))
        setAmount(money(data.amount))
        setDescription(data.description)
        setStatus(data.status)
        setCreateBy(data.createBy)
        setCreateDate(data.createDate)
        setUpdateBy(data.updateBy)
        setUpdateDate(data.updateDate)
    }
    
    useEffect(() => {
        const onLoad = async () => {
            showLoading()

            try {
                await getExpenseCategory()

                if (formType === FormTypeEdit) {
                    await getExpenseById(expenseId)
                }
            }
            finally {
                hideLoading()
            }
        }

        onLoad()
    }, [])

    return(
        <MainBodyCard>
            <div>
                <PagesFormTitle 
                    title='Detail Pengeluaran'
                    formType={formType}
                    status={status}
                    createDate={createDate}
                    updateDate={updateDate}
                    updateBy={updateBy}
                />
                
                <div className="mt-5 flex flex-col gap-3 ">
                    <CardForm title='Tanggal Pengeluaran'>
                        <DatePicker value={expenseDate} onChange={setExpenseDate} disableClock={true} />
                    </CardForm>

                    <CardForm title='Category'>
                        <Select options={expenseCategoryOptions} value={expenseCategoryOptions.find((x) => x.value === expenseCategoryId)} onChange={(e) => { setExpenseCategoryId(e.value) }} placeholder='Select Category' />
                    </CardForm>
                    
                    <CardForm title='Jumlah'>
                        <input className="input" value={amount} onChange={(e) => { setAmount(money(e.target.value)) }} />
                    </CardForm>

                    <CardForm title='Dekripsi'>
                        <input className="input" value={description} onChange={(e) => { setDescription(e.target.value) }} />
                    </CardForm>
                </div>
            </div>            

            {/* Button */}
            <div className="mt-5 flex flex-wrap justify-end gap-2">
                <SaveButton onClick={saveBtnClick} />
                <BackButton onClick={backBtnClick} />
            </div>
        </MainBodyCard>
    )
}

const CardForm = ({ title, children}) => {
    return (
        <div className="flex flex-col sm:flex-row sm:items-center text-sm">
            <div className="w-48">
                <span>{title}</span>
            </div>
            <div className="px-4 hidden sm:block">
                <span>:</span>
            </div>
            <div className="w-full sm:w-72">
                {children}
            </div>
        </div>
    )
}